<template>
  <div class="investigatestyle">
    <!-- 表单 -->
    <el-form label-width="100px" :model="datas" size="small">
      <!-- 标题 -->
      <el-form-item class="lef" label="模块名称">
        <div class="weiz">
          <div class="weiz-content">
            <el-input disabled v-model="datas.moduleName"> </el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item class="lef" label="选中的颜色">
        <!-- 颜色选择器 -->
        <el-color-picker
          v-model="datas.activeColor"
          show-alpha
          class="picker"
          :predefine="predefineColors"
        >
        </el-color-picker>
      </el-form-item>

      <el-form-item class="lef" label="未选中的颜色">
        <!-- 颜色选择器 -->
        <el-color-picker
          v-model="datas.inactiveColor"
          show-alpha
          class="picker"
          :predefine="predefineColors"
        >
        </el-color-picker>
      </el-form-item>
      <div>
        <span>导航内容</span>
        <vuedraggable v-model="datas.iconList" v-bind="dragOptions">
          <transition-group>
            <section
              v-for="(item, index) in datas.iconList"
              :key="item + index"
            >
              <div v-if="item.isActive" class="imgBanner">
                <div>
                  <div style="display: flex; align-items: center">
                    <div
                      class="imagBox"
                      v-if="item.iconPic"
                      style="
                        text-align: center;
                        width: 45px;
                        height: 45px;
                        line-height: 50px;
                      "
                      @click="replaceIcon(1, index)"
                    >
                      <i
                        v-if="item.iconPic.includes('iconfont')"
                        :class="item.iconPic"
                        style="font-size: 30px"
                        :style="{ color: datas.activeColor }"
                      ></i>
                      <van-icon
                        v-else
                        :name="item.iconPic"
                        :color="datas.activeColor"
                        size="30"
                      />
                      <div>选中时</div>
                    </div>
                    <!-- 标题和链接 -->
                    <div class="imgText">
                      <div class="imgText-top">
                        <el-input
                          v-model="item.iconText"
                          placeholder="导航名称"
                          size="mini"
                        />
                        <i class="el-icon-delete" @click="deleteimg(index)" />
                        <!--   <div class="imgText-top-r">
                      <span>小圆点</span>
                      <el-checkbox v-model="item.isDot"></el-checkbox>
                    </div> -->
                      </div>
                    </div>
                  </div>

                  <div style="display: flex; align-items: center">
                    <div
                      class="imagBox"
                      v-if="item.inactive"
                      style="text-align: center; width: 45px; height: 45px"
                      @click="replaceIcon(2, index)"
                    >
                      <i
                        v-if="item.inactive.includes('iconfont')"
                        :class="item.inactive"
                        style="font-size: 30px"
                        :style="{ color: datas.inactiveColor }"
                      ></i>
                      <van-icon
                        v-else
                        :name="item.inactive"
                        :color="datas.inactiveColor"
                        size="30"
                      />
                      <div>未选时</div>
                    </div>
                    <!-- 标题和链接 -->
                    <div class="imgTextChild">
                      <CustomSelectList :datas="item" :isShow="false" />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </transition-group>
        </vuedraggable>
        <div v-if="datas.iconList.filter((item) => item.isActive).length < 5">
          <!-- 添加导航按钮@click="$refs.upload.showUpload()" -->
          <div class="addBtn" @click="addTabbarClick">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </div>
      <div>
        <el-form-item class="lef" label="模块样式">
          <div class="weiz">
            <div class="weiz-container" style="">
              <div
                class="preview-item"
                @click="clickChange(1)"
                :class="{ active: moduleType == 1 }"
              >
                <tabbar1 :datas="datas"></tabbar1>
              </div>
              <div
                class="preview-item"
                style="border-radius: 30px"
                @click="clickChange(2)"
                :class="{ active: moduleType == 2 }"
              >
                <tabbar2 :datas="datas"></tabbar2>
              </div>
              <div
                class="preview-item"
                @click="clickChange(3)"
                :class="{ active: moduleType == 3 }"
              >
                <tabbar3 :datas="datas"></tabbar3>
              </div>
            </div>
          </div>
        </el-form-item>
      </div>
    </el-form>

    <!-- 上传图片 -->
    <image-select-modal
      ref="imageSelectModal"
      :visible.sync="showImageModal"
      @select="handleImageSelect"
    />
    <!-- <uploadimg
      ref="upload"
      @uploadInformation="uploadInformation"
      @handleClose="handleClose"
    /> -->
  </div>
</template>

<script>
import componentProperties from "@/utils/componentProperties"; // 组件数据
import uploadimg from "../../uploadImg"; //图片上传
import vuedraggable from "vuedraggable"; //拖拽组件
export default {
  name: "tabbarstyle",
  components: {
    uploadimg,
    vuedraggable,
  },
  props: {
    datas: Object,
  },
  data() {
    return {
      showImageModal: false,
      predefineColors: [
        // 颜色选择器预设
        "#ff4500",
        "#ff8c00",
        "#ffd700",
        "#90ee90",
        "#00ced1",
        "#1e90ff",
        "#c71585",
        "#409EFF",
        "#909399",
        "#C0C4CC",
        "rgba(255, 69, 0, 0.68)",
        "rgb(255, 120, 0)",
        "hsv(51, 100, 98)",
        "hsva(120, 40, 94, 0.5)",
        "hsl(181, 100%, 37%)",
        "hsla(209, 100%, 56%, 0.73)",
        "#c7158577",
      ],
      optionsType: [
        {
          type: "10",
          name: "内部链接",
        },
        {
          type: "11",
          name: "外部链接",
        },
      ], // 选择跳转类型
      emptyText: "",
      dragOptions: {
        animation: 200,
      },
      replaceIconIndex: null,
      replaceIndex: null,
      moduleType: 1,
    };
  },

  created() {
    // 默认设置内部链接为page_路径
    if (this.datas.iconList && this.datas.iconList.length > 0) {
      this.datas.iconList.forEach((item) => {
        item.http.internalLink = `page_${item.path}`;
      });
    }

    console.log(
      "监听tabbarStyle组件挂载了··········································",
      this.datas.iconList,
    );
  },

  mounted() {},
  computed: {},
  methods: {
    // 模块样式切换
    clickChange(type) {
      this.moduleType = type;
      this.datas.moduleType = type;
      console.log("模块样式切换了", type, this.datas);
    },
    // 添加导航项
    addTabbarClick() {
      // 检查所有项的isActive是否都为false
      const allInactive = this.datas.iconList.every((item) => !item.isActive);

      if (allInactive) {
        // 找到第一个isActive为false的项并设置为true
        for (let i = 0; i < this.datas.iconList.length; i++) {
          if (!this.datas.iconList[i].isActive) {
            this.datas.iconList[i].isActive = true;
            break;
          }
        }
      } else {
        // 如果已有激活项，检查是否可以添加更多（最多5个）
        const activeCount = this.datas.iconList.filter(
          (item) => item.isActive,
        ).length;
        if (activeCount < 5) {
          // 找到第一个isActive为false的项并设置为true
          for (let i = 0; i < this.datas.iconList.length; i++) {
            if (!this.datas.iconList[i].isActive) {
              this.datas.iconList[i].isActive = true;
              break;
            }
          }
        }
      }

      console.log("添加导航后的iconList", this.datas.iconList);
    },
    handleImageSelect(res) {
      // tabbarActiveIndex 1 选中图标  2  未选中图标   tabbarIndex  第几项导航
      if (res.tabbarActiveIndex == 1) {
        this.datas.iconList[res.tabbarIndex].iconPic = res.class;
        this.datas.activeColor = res.activeColor;
      }
      if (res.tabbarActiveIndex == 2) {
        this.datas.iconList[res.tabbarIndex].inactive = res.class;
        this.datas.inactiveColor = res.inactiveColor;
      }
      console.log("点击底部导航的图片了回调方法获取过来的", res, this.datas);
    },
    // 提交
    uploadInformation(res) {
      if (this.replaceIconIndex == 1) {
        this.datas.iconList[this.replaceIndex].iconPic = res;
        this.replaceIconIndex = null;
        return;
      }
      if (this.replaceIconIndex == 2) {
        this.datas.iconList[this.replaceIndex].inactive = res;
        this.replaceIconIndex = null;
        return;
      }
      this.datas.iconList.push({
        /** 图标名称文字 */
        iconText: "",
        /** 图标图片 */
        iconPic: res,
        inactive: res,
        /** 是否显示小圆点 */
        isDot: false,
        /** 跳转类型 */
        linktype: "10",
        /** 跳转参数 */
        http: {},
      });
    },
    /* 取消上传 */
    handleClose() {
      this.replaceIconIndex = null;
    },
    /* 删除图片 */
    deleteimg(index) {
      const newIconList = this.datas.iconList.filter((item) => item.isActive);
      if (newIconList.length == 2) {
        this.$message.error("最少保留2个导航项");
        return;
      }
      this.datas.iconList[index].isActive =
        !this.datas.iconList[index].isActive;
      console.log("删除导航内容了------", index, this.datas, newIconList);
    },
    /* 点击图片 */
    replaceIcon(replaceIconIndex, replaceIndex) {
      this.replaceIconIndex = replaceIconIndex;
      this.replaceIndex = replaceIndex;
      this.showImageModal = true;
      this.$refs.imageSelectModal.tabbarActiveIndex = replaceIconIndex; //选中/未选中图表index
      this.$refs.imageSelectModal.tabbarIndex = replaceIndex; //第几项导航
      // this.$refs.imageSelectModal.customColor = ""//初始化选中的颜色
      // this.$refs.imageSelectModal.selectedImage = null //选中的图标初始化
      //根据replaceIconIndex, replaceIndex 判断datas里的iconList  对应的项里的iconPic 和inactive的字符串是否在对应的illustrationIcons 和colorIcons里，然后对应回显子组件
      const obj = {
        activeColor: this.datas.activeColor,
        inactiveColor: this.datas.inactiveColor,
        className:
          replaceIconIndex == 1
            ? this.datas.iconList[replaceIndex].iconPic
            : this.datas.iconList[replaceIndex].inactive,
        currentItem: this.datas.iconList[replaceIndex],
        // tabbarIndexName: this.datas.iconList[replaceIndex].iconText,
        // tabbarAcitveIndexName: this.datas.iconList[replaceIndex].iconText,
      };
      console.log(
        "开始回哪了",
        replaceIconIndex,
        replaceIndex,
        obj,
        this.datas.iconList,
        this.$refs.imageSelectModal,
      );
      this.$refs.imageSelectModal.echo(obj);
      return;
      console.log(replaceIconIndex, replaceIndex);
      this.$refs.upload.showUpload();
    },
  },
};
</script>

<style lang="scss" scoped>
.addBtn {
  border: 1px solid #c0c0c0;
  border-radius: 10px;
  cursor: pointer;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.addBtn:hover {
  background-color: #f2f4f6;
}
.investigatestyle {
  width: 100%;
  left: 0;
  top: 0;
  padding: 0 10px 20px;
  box-sizing: border-box;
  /* 标题 */
  h2 {
    padding: 24px 16px 24px 0;
    margin-bottom: 15px;
    border-bottom: 1px solid #f2f4f6;
    font-size: 18px;
    font-weight: 600;
    color: #323233;
  }
  .lef {
    ::v-deep.el-form-item__label {
      text-align: left;
    }
  }

  /* 上传图片按钮 */
  .uploadImg {
    width: 330px;
    height: 40px;
    margin-top: 20px;
  }

  /* 卡片列表 */
  .imgBanner {
    padding: 6px 12px;
    margin: 16px 7px;
    border-radius: 2px;
    background-color: #fff;
    box-shadow: 0 0 4px 0 rgba(10, 42, 97, 0.2);
    // display: flex;
    position: relative;

    /* 删除图标 */
    .el-icon-delete {
      cursor: pointer;
      font-size: 19px;
      margin-left: 20px;
    }

    /* 图片 */
    .imagBox {
      position: relative;
      border-radius: 5px;
      overflow: hidden;
      width: 50px;
      cursor: pointer;
      .imag {
        width: 40px;
        height: 40px;
      }
      div {
        position: absolute;
        top: 0;
        width: 40px;
        height: 40px;
        line-height: 40px;
        border-radius: 5px;
        text-align: center;
        font-size: 12px;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.3);
      }
    }
    /* 图片字 */
    .imgTextChild {
      width: 100%;
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      padding-left: 10px;
      .fir-sele.el-select {
        width: 40%;
      }
    }
    /* 图片字 */
    .imgText {
      width: 100%;
      padding-left: 10px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      // justify-content: space-around;

      .imgText-top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .imgText-top-r {
          flex: 1;
          text-align: center;
          span {
            margin-right: 10px;
          }
        }
        ::v-deep.el-input,
        .el-input--mini {
          flex: 1;
        }
      }
    }
  }
  .icon-tip {
    font-size: 12px;
    color: red;
  }
}
</style>
